import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNairaSign } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import image from "../../assets/delete.svg";
import req from "../../axios/interceptedAxiosInstance";
import { successToast } from "../../notification/notification";
import { removeItemFromCart } from "../../slice/cart/cartSlice";
import { useDispatch } from "react-redux";

const CartIndividual = ({ cart }) => {
  const dispatch = useDispatch();
  const [disabled, setDisable] = useState(false);
  const { product, id } = cart;
  const { product_image, seller, product_name, product_prices } = product;
  const { front_view } = product_image;
  const { full_name } = seller;

  const removeFromCart = async () => {
    setDisable(true);
    try {
      const response = await req.delete(`cart/${Number(id)}`);
      dispatch(removeItemFromCart(id));
      successToast(`${response.data.message}: item removed from cart`);
      setDisable(false);
    } catch (error) {
      console.log(error);
      setDisable(false);
    }
  };
  return (
    <div className="border-t border-label mt-3 pt-5 pb-5">
      <div className="flex flex-col lg:flex-row justify-between">
        <div className="flex gap-3">
          <div>
            <img src={front_view} className="w-184 h-152" alt="product" />
          </div>
          <div>
            <p className="text-label text-md">
              Seller: {full_name} Thrift Shop
            </p>
            <p className="text-md">{product_name}</p>
            <p className="font-bold">
              Size:{" "}
              <span className="font-normal">
                {product_prices[0].product_size.code}
              </span>
            </p>
          </div>
        </div>
        <div>
          <p className="text-right">
            <FontAwesomeIcon
              icon={faNairaSign}
              className="font-normal text-sm"
            />
            {product_prices[0].price
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </p>
          <div className="flex justify-end lg:block">
            <button
              disabled={disabled}
              onClick={removeFromCart}
              className="flex justify-center mt-5 rounded-3xl gap-3 items-center bg-lighterGrey h-9 w-48"
            >
              <img src={image} alt="delete" />
              <p>Remove from cart</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartIndividual;
